import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { BRAND, errMsg } from "./constants";

const NEXT = { open: ["in_progress", "resolved"], in_progress: ["resolved"], resolved: [] };
const COLOR = { open: "#DC2626", in_progress: BRAND.orange, resolved: BRAND.green };

export function ComplaintsPanel({ pid, authFetch, API }) {
  const [items, setItems] = useState([]);
  const load = useCallback(() => authFetch({ url: `${API}/homestay/properties/${pid}/complaints` }).then((r) => setItems(r.data.items)).catch(() => {}), [pid, authFetch, API]);
  useEffect(() => { load(); }, [load]);

  const move = async (c, status) => {
    const response = window.prompt("Reply to guest (optional)", status === "resolved" ? "Fixed — thanks for flagging!" : "We're on it.");
    if (response === null) return;
    try { await authFetch({ method: "patch", url: `${API}/homestay/complaints/${c.id}`, data: { status, response } }); toast.success("Updated & guest notified"); load(); }
    catch (e) { toast.error(errMsg(e, "Could not update")); }
  };

  return (
    <div data-testid="complaints-panel" className="rounded-2xl border-2 bg-white p-4" style={{ borderColor: BRAND.line }}>
      <div className="text-sm font-bold" style={{ color: BRAND.green }}>Complaints & suggestions</div>
      {items.length === 0 && <div className="text-xs mt-3" style={{ color: BRAND.muted }} data-testid="complaints-empty">All quiet — no complaints.</div>}
      <div className="mt-2 max-h-[28rem] overflow-y-auto">
        {items.map((c) => (
          <div key={c.id} data-testid={`complaint-row-${c.id}`} className="py-3 border-t text-sm" style={{ borderColor: BRAND.line }}>
            <div className="flex justify-between gap-2">
              <div className="font-bold">{c.guest_name} <span className="chip text-[10px]">{c.kind} · {c.category}</span></div>
              <span data-testid={`complaint-status-${c.id}`} className={`text-[10px] font-bold uppercase ${c.status === "open" ? "bed-blink" : ""}`} style={{ color: COLOR[c.status] }}>{c.status.replace("_", " ")}</span>
            </div>
            <div className="text-xs mt-0.5">{c.text}</div>
            {c.response && <div className="text-xs mt-1" style={{ color: BRAND.muted }}>↳ {c.response}</div>}
            <div className="mt-2 flex gap-2">
              {NEXT[c.status].map((s) => (
                <button key={s} data-testid={`complaint-${s}-${c.id}`} onClick={() => move(c, s)} className="rounded-full border px-2.5 py-1 text-[11px] font-bold" style={{ borderColor: COLOR[s], color: COLOR[s] }}>
                  {s === "resolved" ? "Mark resolved" : "Start work"}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
